import type { ReactElement } from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '../auth/AuthContext.js';
import { DatabaseSection } from './settings/DatabaseSection.js';
import { ThemeSection } from './settings/ThemeSection.js';
import { UserManagement } from './settings/UserManagement.js';

export function Settings(): ReactElement {
  const { logout } = useAuth();

  function onSignOut(): void {
    void logout();
  }

  return (
    <div
      className="mx-auto flex w-full max-w-[430px] flex-col gap-4 p-4"
      data-testid="settings-view"
    >
      <h1 className="text-2xl font-semibold" style={{ color: 'var(--text-main)' }}>
        Settings
      </h1>
      <ThemeSection />
      <UserManagement />
      <DatabaseSection />
      <button
        type="button"
        onClick={onSignOut}
        className="flex items-center justify-center gap-2 rounded-md border px-3 py-2 text-sm font-medium"
        data-testid="sign-out-button"
        style={{
          background: 'transparent',
          borderColor: 'var(--border)',
          color: 'var(--text-main)',
          minHeight: 48,
        }}
      >
        <LogOut size={16} aria-hidden="true" />
        Sign out
      </button>
    </div>
  );
}